export const BASE_IMAGE_URI = 'https://cdnimg.spectrum.net';
// export const BASE_IMAGE_URI = 'https://spectrum-agency-prod.apigee.net';
